// extracted by mini-css-extract-plugin
export default {"countdown":"styles_countdown__18o2x"};